import { createSelector } from '@ngrx/store';
import { currentLocationState } from '../root';

export const getCurrentLocationNo = createSelector(currentLocationState, (currentLocation) => currentLocation?.locationNo);
